const teams = {
  americanFootball: [
    {
      value: 'Abilene Christian University',
      players: []
    },
    {
      value: 'Alabama A&M University',
      players: []
    },
    {
      value: 'Alabama State University',
      players: []
    },
    {
      value: 'Alcorn State University',
      players: []
    },
    {
      value: 'Appalachian State University',
      players: []
    },
    {
      value: 'Arizona State University',
      players: []
    },
    {
      value: 'Arkansas State University',
      players: []
    },
    {
      value: 'Auburn University',
      players: []
    },
    {
      value: 'Austin Peay State University',
      players: []
    },
    {
      value: 'Ball State University',
      players: []
    },
    {
      value: 'Baylor University',
      players: []
    },
    {
      value: 'Bethune-Cookman University',
      players: []
    },
    {
      value: 'Boise State University',
      players: []
    },
    {
      value: 'Boston College',
      players: []
    },
    {
      value: 'Bowling Green State University',
      players: []
    },
    {
      value: 'Brigham Young University',
      players: []
    },
    {
      value: 'Brown University',
      players: []
    },
    {
      value: 'Bryant University',
      players: []
    },
    {
      value: 'Bucknell University',
      players: []
    },
    {
      value: 'Butler University',
      players: []
    },
    {
      value: 'California Polytechnic State University – San Luis Obispo',
      players: []
    },
    {
      value: 'California State University – Fresno',
      players: []
    },
    {
      value: 'University – Fresno',
      players: []
    },
    {
      value: 'California State University – Sacramento',
      players: []
    },
    {
      value: 'Campbell University',
      players: []
    },
    {
      value: 'Central Connecticut State University',
      players: []
    },
    {
      value: 'Central Michigan University',
      players: []
    },
    {
      value: 'Charleston Southern University',
      players: []
    },
    {
      value: 'Clemson University',
      players: []
    },
    {
      value: 'Coastal Carolina University',
      players: []
    },
    {
      value: 'Colgate University',
      players: []
    },
    {
      value: 'College of the Holy Cross',
      players: []
    },
    {
      value: 'Colorado State University',
      players: []
    },
    {
      value: 'Columbia University',
      players: []
    },
    {
      value: 'Cornell University',
      players: []
    },
    {
      value: 'Dartmouth College',
      players: []
    },
    {
      value: 'Davidson College',
      players: []
    },
    {
      value: 'Delaware State University',
      players: []
    },
    {
      value: 'Drake University',
      players: []
    },
    {
      value: 'Duke University',
      players: []
    },
    {
      value: 'Duquesne University',
      players: []
    },
    {
      value: 'East Carolina University',
      players: []
    },
    {
      value: 'East Tennessee State University',
      players: []
    },
    {
      value: 'Eastern Illinois University',
      players: []
    },
    {
      value: 'Eastern Kentucky University',
      players: []
    },
    {
      value: 'Eastern Michigan University',
      players: []
    },
    {
      value: 'Eastern Washington University',
      players: []
    },
    {
      value: 'Elon University',
      players: []
    },
    {
      value: 'Florida A&M University',
      players: []
    },
    {
      value: 'Florida Atlantic University',
      players: []
    },
    {
      value: 'Florida International University',
      players: []
    },
    {
      value: 'Florida State University',
      players: []
    },
    {
      value: 'Fordham University',
      players: []
    },
    {
      value: 'Furman University',
      players: []
    },
    {
      value: 'Gardner-Webb University',
      players: []
    },
    {
      value: 'Georgetown University',
      players: []
    },
    {
      value: 'Georgia Southern University',
      players: []
    },
    {
      value: 'Georgia State University',
      players: []
    },
    {
      value: 'Georgia Tech',
      players: []
    },
    {
      value: 'Grambling State University',
      players: []
    },
    {
      value: 'Hampton University',
      players: []
    },
    {
      value: 'Harvard University',
      players: []
    },
    {
      value: 'Houston Baptist University',
      players: []
    },
    {
      value: 'Howard University',
      players: []
    },
    {
      value: 'Idaho State University',
      players: []
    },
    {
      value: 'Illinois State University',
      players: []
    },
    {
      value: 'Indiana State University',
      players: []
    },
    {
      value: 'Indiana University',
      players: []
    },
    {
      value: 'Iowa State University',
      players: []
    },
    {
      value: 'Jackson State University',
      players: []
    },
    {
      value: 'Jacksonville State University',
      players: []
    },
    {
      value: 'James Madison University',
      players: []
    },
    {
      value: 'Kansas State University',
      players: []
    },
    {
      value: 'Kennesaw State University',
      players: []
    },
    {
      value: 'Kent State University',
      players: []
    },
    {
      value: 'Lafayette College',
      players: []
    },
    {
      value: 'Lamar University',
      players: []
    },
    {
      value: 'Lehigh University',
      players: []
    },
    {
      value: 'Liberty University',
      players: []
    },
    {
      value: 'Lindenwood University',
      players: []
    }
  ],
  soccer: [
    {
      value: 'AC Milan',
      players: []
    },
    {
      value: 'Genoa CFC',
      players: []
    },
    {
      value: 'Juventus Next Gen',
      players: []
    },
    {
      value: 'Virtus Entella',
      players: []
    },
    {
      value: 'FC Crotone',
      players: []
    },
    {
      value: 'Sanremese Calcio',
      players: []
    },
    {
      value: 'Franciacorta FC',
      players: []
    },
    {
      value: 'Union Clodiense Chioggia',
      players: []
    },
    {
      value: 'US Pistoiese 1921',
      players: []
    },
    {
      value: 'SS Arezzo',
      players: []
    },
    {
      value: 'AS Sambenedettese',
      players: []
    },
    {
      value: 'Casertana FC',
      players: []
    },
    {
      value: 'Brindisi FC',
      players: []
    },
    {
      value: 'Catania SSD',
      players: []
    },
    {
      value: ' Inter Milan',
      players: []
    },
    {
      value: 'Parma Calcio 1913',
      players: []
    },
    {
      value: 'LR Vicenza',
      players: []
    },
    {
      value: 'AC Reggiana 1919',
      players: []
    },
    {
      value: 'Delfino Pescara 1936',
      players: []
    },
    {
      value: 'FBC Casale',
      players: []
    },
    {
      value: 'Alcione Milano',
      players: []
    },
    {
      value: 'Luparense FC',
      players: []
    },
    {
      value: 'AC Carpi',
      players: []
    },
    {
      value: 'AS Ostiamare Lido Calcio',
      players: []
    },
    {
      value: 'Pineto Calcio',
      players: []
    },
    {
      value: 'Costa Orientale Sarda',
      players: []
    },
    {
      value: 'Cavese 1919',
      players: []
    },
    {
      value: 'FC Trapani 1905',
      players: []
    },
    {
      value: ' SSC Napoli',
      players: []
    },
    {
      value: 'Venezia FC',
      players: []
    },
    {
      value: 'US Triestina',
      players: []
    },
    {
      value: 'Cesena FC',
      players: []
    },
    {
      value: 'US Catanzaro',
      players: []
    },
    {
      value: 'USD Sestri Levante 1919',
      players: []
    },
    {
      value: 'Sona Calcio',
      players: []
    },
    {
      value: 'Dolomiti Bellunesi',
      players: []
    },
    {
      value: 'AS Giana Erminio',
      players: []
    },
    {
      value: 'US Follonica Gavorrano',
      players: []
    },
    {
      value: 'Nuova Florida Calcio',
      players: []
    },
    {
      value: 'Sorrento 1945',
      players: []
    },
    {
      value: 'Afragolese 1944',
      players: []
    },
    {
      value: 'FC Lamezia Terme',
      players: []
    },
    {
      value: ' Juventus FC',
      players: []
    },
    {
      value: 'Caliari Calcio',
      players: []
    },
    {
      value: 'Calcio Padova',
      players: []
    },
    {
      value: 'ACR Siena 1904',
      players: []
    },
    {
      value: 'Calcio Foggia 1920',
      players: []
    },
    {
      value: 'FC Vado',
      players: []
    },
    {
      value: 'ASD Citta Di Varese',
      players: []
    },
    {
      value: 'Cjarlins Muzane',
      players: []
    },
    {
      value: 'Lentigione Calcio',
      players: []
    },
    {
      value: 'US Livorno 1915',
      players: []
    },
    {
      value: 'Cynthialbalonga Calcio',
      players: []
    },
    {
      value: 'Paganese Calcio 1926',
      players: []
    },
    {
      value: 'Casarano Calcio',
      players: []
    },
    {
      value: 'US Vibonese',
      players: []
    },
    {
      value: ' AS Roma',
      players: []
    },
    {
      value: 'Pisa Sporting Club',
      players: []
    },
    {
      value: 'Pordenone Calcio',
      players: []
    },
    {
      value: 'AS Gubbio 1910',
      players: []
    },
    {
      value: 'US Avellino 1912',
      players: []
    },
    {
      value: 'ASD Chieri Calcio',
      players: []
    },
    {
      value: 'Calcio Brusaporto',
      players: []
    },
    {
      value: 'FC Lagnago Salus',
      players: []
    },
    {
      value: 'Ravenna FC',
      players: []
    },
    {
      value: 'US Grosseto 1912',
      players: []
    },
    {
      value: 'ASD Vastese Calcio 1902',
      players: []
    },
    {
      value: 'Arzachena Academy',
      players: []
    },
    {
      value: 'Molfetta Calcio',
      players: []
    },
    {
      value: 'Acireale Calcio',
      players: []
    },
    {
      value: ' Atlanta BC',
      players: []
    },
    {
      value: 'Benevento Calcio',
      players: []
    },
    {
      value: 'Novara FC',
      players: []
    },
    {
      value: 'Cearrarese Calcio 1908',
      players: []
    },
    {
      value: 'SS Turris Calcio',
      players: []
    },
    {
      value: 'Darthona FBC',
      players: []
    },
    {
      value: 'FC Lumezzane',
      players: []
    },
    {
      value: 'US Adriese 1906',
      players: []
    },
    {
      value: 'AC Prato',
      players: []
    },
    {
      value: 'AC Citta di Castello',
      players: []
    },
    {
      value: "SSD Porto D'Ascoli",
      players: []
    },
    {
      value: 'SS Nola 1925',
      players: []
    },
    {
      value: 'AC Nardo',
      players: []
    },
    {
      value: 'ASD San Luca',
      players: []
    },
    {
      value: ' SS Lazio',
      players: []
    },
    {
      value: 'Como 1907',
      players: []
    },
    {
      value: 'FC Pro Vercelli 1892',
      players: []
    },
    {
      value: 'Rimini FC',
      players: []
    },
    {
      value: 'SS Juva Stabia',
      players: []
    },
    {
      value: 'SC Ligorna 1922',
      players: []
    },
    {
      value: 'GS Arconatese',
      players: []
    },
    {
      value: 'Caldiero Terme',
      players: []
    },
    {
      value: 'United Riccione',
      players: []
    },
    {
      value: 'Mobilieri Ponsacco',
      players: []
    },
    {
      value: 'Alma Juventus Fano 1906',
      players: []
    },
    {
      value: 'Vis Artena',
      players: []
    },
    {
      value: 'FC Francavilla 1931',
      players: []
    },
    {
      value: "Citta di Sant'Agata",
      players: []
    },
    {
      value: ' ACF Florentina',
      players: []
    },
    {
      value: 'Frosinone Calcio',
      players: []
    },
    {
      value: 'Feralpisalo',
      players: []
    },
    {
      value: 'Vis Pesaro 1898',
      players: []
    },
    {
      value: 'SS Monopoli 1966',
      players: []
    },
    {
      value: 'Legnano AC',
      players: []
    },
    {
      value: 'USD Breno',
      players: []
    },
    {
      value: 'AC Campodarsego',
      players: []
    },
    {
      value: 'Forli FC',
      players: []
    },
    {
      value: 'Montespaccato Calcio',
      players: []
    },
    {
      value: 'Trastevere Calcio',
      players: []
    },
    {
      value: 'LVPA Frascati',
      players: []
    },
    {
      value: 'ASD Team Altamura',
      players: []
    },
    {
      value: 'Santa Maria Cilento',
      players: []
    },
    {
      value: ' US Sassuolo',
      players: []
    },
    {
      value: 'Palermo FC',
      players: []
    },
    {
      value: 'AC Trento',
      players: []
    },
    {
      value: 'Lucchese 1905',
      players: []
    },
    {
      value: 'Virtus Francavilla Calcio',
      players: []
    },
    {
      value: 'AC Bra',
      players: []
    },
    {
      value: '1913 Seregno Calcio',
      players: []
    },
    {
      value: 'AC Este 1920',
      players: []
    },
    {
      value: 'AC Crema 1908',
      players: []
    },
    {
      value: 'Flaminia Civita Castellana',
      players: []
    },
    {
      value: 'Termoli Calcio 1920',
      players: []
    },
    {
      value: 'Real Monterotondo',
      players: []
    },
    {
      value: 'Nocerina Calcio',
      players: []
    },
    {
      value: 'Real Agro Aversa',
      players: []
    },
    {
      value: ' Torino FC',
      players: []
    },
    {
      value: 'Brescia Calcio',
      players: []
    },
    {
      value: 'UC AlbioLeffe',
      players: []
    },
    {
      value: 'US Ancona',
      players: []
    },
    {
      value: 'Latina Calcio 1932',
      players: []
    },
    {
      value: 'USD Castellanzese 1921',
      players: []
    },
    {
      value: 'AC Ponte San Pietro',
      players: []
    },
    {
      value: 'AC Mestre',
      players: []
    },
    {
      value: "Sant'Angelo",
      players: []
    },
    {
      value: 'Seravezza Pozzi Calcio',
      players: []
    },
    {
      value: 'Roma City FC',
      players: []
    },
    {
      value: 'Portici 1906',
      players: []
    },
    {
      value: 'Martina Calcio 1947',
      players: []
    },
    {
      value: 'Licata Calcio',
      players: []
    },
    {
      value: ' Udinese Calcio',
      players: []
    },
    {
      value: 'Ternana Calcio',
      players: []
    },
    {
      value: 'AC Renate',
      players: []
    },
    {
      value: 'US Citta di Pontedera',
      players: []
    },
    {
      value: 'Potenza Calcio',
      players: []
    },
    {
      value: 'ASDC Gozzano',
      players: []
    },
    {
      value: 'Villa Valle',
      players: []
    },
    {
      value: 'Prodeco Calcio Montebelluna',
      players: []
    },
    {
      value: 'ASD Fanfulla',
      players: []
    },
    {
      value: 'US Poggibonsi',
      players: []
    },
    {
      value: 'FC Matese',
      players: []
    },
    {
      value: 'Cassino Calcio 1924',
      players: []
    },
    {
      value: 'FC Matera',
      players: []
    },
    {
      value: 'Ragusa Calcio',
      players: []
    },
    {
      value: ' Bologna FC 1909',
      players: []
    },
    {
      value: 'SSC Bari',
      players: []
    },
    {
      value: 'Calcio Lecco 1912',
      players: []
    },
    {
      value: 'US Florenzuola 1922',
      players: []
    },
    {
      value: 'Audace Cerignola',
      players: []
    },
    {
      value: 'Borgosesia Calcio',
      players: []
    },
    {
      value: 'Calcio Desenzano',
      players: []
    },
    {
      value: 'Us Levico Terme',
      players: []
    },
    {
      value: 'Corregese Calcio 1948',
      players: []
    },
    {
      value: 'US Pianese',
      players: []
    },
    {
      value: 'Tolentino Calcio',
      players: []
    },
    {
      value: 'Palmese',
      players: []
    },
    {
      value: 'Gladiator 1924',
      players: []
    },
    {
      value: 'US Mariglianese',
      players: []
    },
    {
      value: ' AC Monza',
      players: []
    },
    {
      value: 'SPAL',
      players: []
    },
    {
      value: 'Mantova 1911',
      players: []
    },
    {
      value: 'Olbia Calcio 1905',
      players: []
    },
    {
      value: 'Monterosi Tuscia FC',
      players: []
    },
    {
      value: 'ASD Asti',
      players: []
    },
    {
      value: 'Virtus Ciserano Bergamo 1909',
      players: []
    },
    {
      value: 'ASD Cartigliano',
      players: []
    },
    {
      value: 'USD Real Forte Querceta',
      players: []
    },
    {
      value: 'Sporting Club Trestina',
      players: []
    },
    {
      value: 'Montegiorgio Calcio',
      players: []
    },
    {
      value: 'US Angri 1927',
      players: []
    },
    {
      value: 'FBC Gravina',
      players: []
    },
    {
      value: 'Cittanova Calcio',
      players: []
    },
    {
      value: ' US Salernitana 1919',
      players: []
    },
    {
      value: 'Ascoli Calcio',
      players: []
    },
    {
      value: 'Sangiuliano City',
      players: []
    },
    {
      value: 'Imolese Calcio 1919',
      players: []
    },
    {
      value: 'Fidelis Andria 2018',
      players: []
    },
    {
      value: 'GS Castanese',
      players: []
    },
    {
      value: 'Casatese',
      players: []
    },
    {
      value: 'UC Montecchio Maggiore',
      players: []
    },
    {
      value: 'FC Scandicci 1908',
      players: []
    },
    {
      value: 'GSD Ghiviborgo VDS',
      players: []
    },
    {
      value: 'Chieti FC 1922',
      players: []
    },
    {
      value: 'Aprilia Calcio',
      players: []
    },
    {
      value: 'US Bitonto Calcio',
      players: []
    },
    {
      value: 'Castrovillari Calcio',
      players: []
    },
    {
      value: ' FC Empoli',
      players: []
    },
    {
      value: 'Reggina 1914',
      players: []
    },
    {
      value: 'Aurora Pro Patria',
      players: []
    },
    {
      value: 'Aquila Montevarchi 1902',
      players: []
    },
    {
      value: 'US Viterbese 1908',
      players: []
    },
    {
      value: 'PonDonnaz Hone Arnad Evancon',
      players: []
    },
    {
      value: 'Real Calepina FC',
      players: []
    },
    {
      value: 'Virtus Bolzano',
      players: []
    },
    {
      value: 'Sammaurese Calcio',
      players: []
    },
    {
      value: 'Sangiovannese 1927',
      players: []
    },
    {
      value: 'Notaresco Calcio',
      players: []
    },
    {
      value: 'Atletico Uri',
      players: []
    },
    {
      value: 'US Citta di Fasano',
      players: []
    },
    {
      value: 'Paterno Calcio',
      players: []
    },
    {
      value: ' Hellas Verona',
      players: []
    },
    {
      value: 'AC Perugia Calcio',
      players: []
    },
    {
      value: 'US Pergolettese 1932',
      players: []
    },
    {
      value: 'US Allesandria Calcio 1912',
      players: []
    },
    {
      value: 'Taranto FC 1927',
      players: []
    },
    {
      value: 'Fossano Calcio',
      players: []
    },
    {
      value: 'SC Caronnese',
      players: []
    },
    {
      value: 'ASD Villafranca Veronese',
      players: []
    },
    {
      value: 'Mezzolara Calcio',
      players: []
    },
    {
      value: 'ASD Tau Calcio Altopascio',
      players: []
    },
    {
      value: 'Vastogirardi Calcio',
      players: []
    },
    {
      value: 'Tivoli Calcio 1919',
      players: []
    },
    {
      value: 'USD Lavello',
      players: []
    },
    {
      value: 'AC Locri 1909',
      players: []
    },
    {
      value: ' US Cremonese',
      players: []
    },
    {
      value: 'AS Cittadella',
      players: []
    },
    {
      value: 'Virtusvecomp Verona',
      players: []
    },
    {
      value: 'San Donato Tavarnelle',
      players: []
    },
    {
      value: 'AZ Picerno',
      players: []
    },
    {
      value: 'USD Fezzanese',
      players: []
    },
    {
      value: 'US Folgore Caratese',
      players: []
    },
    {
      value: 'ASD Torviscosa',
      players: []
    },
    {
      value: 'Aglianese Calcio 1923',
      players: []
    },
    {
      value: 'Orvietana Calcio',
      players: []
    },
    {
      value: 'Avezzano Calcio',
      players: []
    },
    {
      value: 'ASD Ilvamaddalena 1903',
      players: []
    },
    {
      value: 'ASD Puteolana 1902',
      players: []
    },
    {
      value: 'Sancataldese Calcio',
      players: []
    },
    {
      value: ' US Lecce',
      players: []
    },
    {
      value: 'Modena FC',
      players: []
    },
    {
      value: 'Piacenza Calcio 1919',
      players: []
    },
    {
      value: 'SEF Torres 1903',
      players: []
    },
    {
      value: 'ACR Messina',
      players: []
    },
    {
      value: 'ASD Stresa Vergante',
      players: []
    },
    {
      value: 'Varesina Calcio',
      players: []
    },
    {
      value: 'Portufuaro Calcio',
      players: []
    },
    {
      value: 'GS Bagnolese',
      players: []
    },
    {
      value: 'ASD Terranuopva Traiana',
      players: []
    },
    {
      value: 'FC Vigor Senigallia',
      players: []
    },
    {
      value: 'Pomezia Calcio',
      players: []
    },
    {
      value: 'Barletta 1922',
      players: []
    },
    {
      value: 'ASD Canicatti',
      players: []
    },
    {
      value: ' Spezia Calcio',
      players: []
    },
    {
      value: 'Cosenza Calcio',
      players: []
    },
    {
      value: 'Arizgnano Valchiampo',
      players: []
    },
    {
      value: 'Fermana FC',
      players: []
    },
    {
      value: 'Gelbison',
      players: []
    },
    {
      value: 'Pinerolo FC',
      players: []
    },
    {
      value: 'Salsomaggiore Calcio',
      players: []
    },
    {
      value: ' UC Sampdoria',
      players: []
    },
    {
      value: 'FC Sudirol',
      players: []
    },
    {
      value: 'Pro Sesto 1913',
      players: []
    },
    {
      value: 'US Recanatese',
      players: []
    },
    {
      value: 'Giugliano Calcio 1928',
      players: []
    },
    {
      value: 'ASD Chisola Calcio',
      players: []
    },
    {
      value: 'US Corticella',
      players: []
    }
  ],
  basketball: [
    {
      value: 'Boulogne-Levallois',
      players: []
    },
    {
      value: 'Cholet',
      players: []
    },
    {
      value: 'Monaco',
      players: []
    },
    {
      value: 'Dijon',
      players: []
    },
    {
      value: 'Le Mans',
      players: []
    },
    {
      value: 'Asvel',
      players: []
    },
    {
      value: 'Bourg-en-Bresse',
      players: []
    },
    {
      value: 'Limoges CSP',
      players: []
    },
    {
      value: 'Blois',
      players: []
    },
    {
      value: 'Nanterre',
      players: []
    },
    {
      value: 'Nancy',
      players: []
    },
    {
      value: 'Paris',
      players: []
    },
    {
      value: 'Roanne',
      players: []
    },
    {
      value: 'Pau-Lacq-Orthez',
      players: []
    },
    {
      value: 'Gravelines-Dunkerque',
      players: []
    },
    {
      value: 'Strasbourg',
      players: []
    },
    {
      value: 'Fos-sur-Mer',
      players: []
    },
    {
      value: 'Le Portel',
      players: []
    },
    {
      value: 'Boston Celtics',
      players: []
    },
    {
      value: 'Milwaukee Bucks',
      players: []
    },
    {
      value: 'Cleveland Cavaliers',
      players: []
    },
    {
      value: 'Indiana Pacers',
      players: []
    },
    {
      value: 'Phladelphia 76ers',
      players: []
    },
    {
      value: 'Toronto Raptors',
      players: []
    },
    {
      value: 'Atlanta Hawks',
      players: []
    },
    {
      value: 'Washington Wizards',
      players: []
    },
    {
      value: 'Brooklyn Nets',
      players: []
    },
    {
      value: 'Miami Heat',
      players: []
    },
    {
      value: 'Chicago Bulls',
      players: []
    },
    {
      value: 'New York Knicks',
      players: []
    },
    {
      value: 'Charlotte Hornets',
      players: []
    },
    {
      value: 'Orlando Magic',
      players: []
    },
    {
      value: 'Detroit Pistons',
      players: []
    },
    {
      value: 'Phoenis Suns',
      players: []
    },
    {
      value: 'Denver Nuggets',
      players: []
    },
    {
      value: 'Memphis Grizzlies',
      players: []
    },
    {
      value: 'New Orleans Pelicans',
      players: []
    },
    {
      value: 'Los Angeles Clippers',
      players: []
    },
    {
      value: 'Portland Trail Blazers',
      players: []
    },
    {
      value: 'Sacrameto Kings',
      players: []
    },
    {
      value: 'Golden States Warriors',
      players: []
    },
    {
      value: 'Utah Jazz',
      players: []
    },
    {
      value: 'Minnesota Timberwolves',
      players: []
    },
    {
      value: 'Dallas Mavericks',
      players: []
    },
    {
      value: 'Oklahoma City Thunder',
      players: []
    },
    {
      value: 'Los Angeles Lakers',
      players: []
    },
    {
      value: 'San Antonio Spurs',
      players: []
    },
    {
      value: 'Houston Rockets',
      players: []
    },
    {
      value: 'Austin Peay Governors',
      players: []
    },
    {
      value: 'Bellarmine Knights',
      players: []
    },
    {
      value: 'Central Arkansas Bears',
      players: []
    },
    {
      value: 'Eastern Kentucky Colonels',
      players: []
    },
    {
      value: 'Florida Gulf Coast Eagles',
      players: []
    },
    {
      value: 'Jacksonville Dolphins',
      players: []
    },
    {
      value: 'Jacksonville State Gamecocks',
      players: []
    },
    {
      value: 'Kennesaw State Owls',
      players: []
    },
    {
      value: 'Liberty Flames',
      players: []
    },
    {
      value: 'Lipscomb Bisons',
      players: []
    },
    {
      value: 'North Alabama Lions',
      players: []
    },
    {
      value: 'North Florida Ospreys',
      players: []
    },
    {
      value: 'Queens University Royals',
      players: []
    },
    {
      value: 'Stetson Hatters',
      players: []
    },
    {
      value: 'America East',
      players: []
    },
    {
      value: 'Albany Great Danes',
      players: []
    },
    {
      value: 'Binghamton Bearcats',
      players: []
    },
    {
      value: 'Bryant Bulldogs',
      players: []
    },
    {
      value: 'Maine Black Bears',
      players: []
    },
    {
      value: 'NJIT Highlanders',
      players: []
    },
    {
      value: 'New Hampshire Wildcats',
      players: []
    },
    {
      value: 'UMBC Retrievers',
      players: []
    },
    {
      value: 'UMass Lowell River Hawks',
      players: []
    },
    {
      value: 'Vermont Catamounts',
      players: []
    },
    {
      value: 'Cincinnati Bearcats',
      players: []
    },
    {
      value: 'East Carolina Pirates',
      players: []
    },
    {
      value: 'Houston Cougars',
      players: []
    },
    {
      value: 'Memphis Tigers',
      players: []
    },
    {
      value: 'SMU Mustangs',
      players: []
    },
    {
      value: 'South Florida Bulls',
      players: []
    },
    {
      value: 'Temple Owls',
      players: []
    },
    {
      value: 'Tulane Green Wave',
      players: []
    },
    {
      value: 'Tulsa Golden Hurricane',
      players: []
    },
    {
      value: 'UCF Knights',
      players: []
    },
    {
      value: 'Wichita State Shockers',
      players: []
    },
    {
      value: 'Atlantic 10',
      players: []
    },
    {
      value: 'Davidson Wildcats',
      players: []
    },
    {
      value: 'Dayton Flyers',
      players: []
    },
    {
      value: 'Duquesne Dukes',
      players: []
    },
    {
      value: 'Fordham Rams',
      players: []
    },
    {
      value: 'George Mason Patriots',
      players: []
    },
    {
      value: 'George Washington Colonials',
      players: []
    },
    {
      value: 'La Salle Explorers',
      players: []
    },
    {
      value: 'Loyola Chicago Ramblers',
      players: []
    },
    {
      value: 'Rhode Island Rams',
      players: []
    },
    {
      value: 'Richmond Spiders',
      players: []
    },
    {
      value: "Saint Joseph's Hawks",
      players: []
    },
    {
      value: 'Saint Louis Billikens',
      players: []
    },
    {
      value: 'St. Bonaventure Bonnies',
      players: []
    },
    {
      value: 'UMass Minutemen',
      players: []
    },
    {
      value: 'VCU Rams',
      players: []
    },
    {
      value: 'Boston College Eagles',
      players: []
    },
    {
      value: 'Clemson Tigers',
      players: []
    },
    {
      value: 'Duke Blue Devils',
      players: []
    },
    {
      value: 'Florida State Seminoles',
      players: []
    },
    {
      value: 'Georgia Tech Yellow Jackets',
      players: []
    },
    {
      value: 'Louisville Cardinals',
      players: []
    },
    {
      value: 'Miami Hurricanes',
      players: []
    },
    {
      value: 'NC State Wolfpack',
      players: []
    },
    {
      value: 'North Carolina Tar Heels',
      players: []
    },
    {
      value: 'Notre Dame Fighting Irish',
      players: []
    },
    {
      value: 'Pittsburgh Panthers',
      players: []
    },
    {
      value: 'Syracuse Orange',
      players: []
    },
    {
      value: 'Virginia Cavaliers',
      players: []
    },
    {
      value: 'Virginia Tech Hokies',
      players: []
    },
    {
      value: 'Wake Forest Demon Deacons',
      players: []
    },
    {
      value: 'Baylor Bears',
      players: []
    },
    {
      value: 'Iowa State Cyclones',
      players: []
    },
    {
      value: 'Kansas Jayhawks',
      players: []
    },
    {
      value: 'Kansas State Wildcats',
      players: []
    },
    {
      value: 'Oklahoma Sooners',
      players: []
    },
    {
      value: 'Oklahoma State Cowboys',
      players: []
    },
    {
      value: 'TCU Horned Frogs',
      players: []
    },
    {
      value: 'Texas Longhorns',
      players: []
    },
    {
      value: 'Texas Tech Red Raiders',
      players: []
    },
    {
      value: 'West Virginia Mountaineers',
      players: []
    },
    {
      value: 'Butler Bulldogs',
      players: []
    },
    {
      value: 'Creighton Bluejays',
      players: []
    },
    {
      value: 'DePaul Blue Demons',
      players: []
    },
    {
      value: 'Georgetown Hoyas',
      players: []
    },
    {
      value: 'Marquette Golden Eagles',
      players: []
    },
    {
      value: 'Providence Friars',
      players: []
    },
    {
      value: 'Seton Hall Pirates',
      players: []
    },
    {
      value: "St. John's Red Storm",
      players: []
    },
    {
      value: 'UConn Huskies',
      players: []
    },
    {
      value: 'Villanova Wildcats',
      players: []
    },
    {
      value: 'Xavier Musketeers',
      players: []
    },
    {
      value: 'Eastern Washington Eagles',
      players: []
    },
    {
      value: 'Idaho State Bengals',
      players: []
    },
    {
      value: 'Idaho Vandals',
      players: []
    },
    {
      value: 'Montana Grizzlies',
      players: []
    },
    {
      value: 'Montana State Bobcats',
      players: []
    },
    {
      value: 'Northern Arizona Lumberjacks',
      players: []
    },
    {
      value: 'Northern Colorado Bears',
      players: []
    },
    {
      value: 'Portland State Vikings',
      players: []
    },
    {
      value: 'Sacramento State Hornets',
      players: []
    },
    {
      value: 'Weber State Wildcats',
      players: []
    },
    {
      value: 'Campbell Fighting Camels',
      players: []
    },
    {
      value: 'Charleston Southern Buccaneers',
      players: []
    },
    {
      value: "Gardner-Webb Runnin' Bulldogs",
      players: []
    },
    {
      value: 'High Point Panthers',
      players: []
    },
    {
      value: 'Michigan State Spartans',
      players: []
    },
    {
      value: 'Michigan Wolverines',
      players: []
    },
    {
      value: 'Minnesota Golden Gophers',
      players: []
    },
    {
      value: 'Nebraska Cornhuskers',
      players: []
    },
    {
      value: 'Northwestern Wildcats',
      players: []
    },
    {
      value: 'Ohio State Buckeyes',
      players: []
    },
    {
      value: 'Penn State Nittany Lions',
      players: []
    },
    {
      value: 'Purdue Boilermakers',
      players: []
    },
    {
      value: 'Rutgers Scarlet Knights',
      players: []
    },
    {
      value: 'Wisconsin Badgers',
      players: []
    },
    {
      value: 'Cal Poly Mustangs',
      players: []
    },
    {
      value: 'Cal State Bakersfield Roadrunners',
      players: []
    },
    {
      value: 'Cal State Fullerton Titans',
      players: []
    },
    {
      value: 'Cal State Northridge Matadors',
      players: []
    },
    {
      value: "Hawai'i Rainbow Warriors",
      players: []
    },
    {
      value: 'Long Beach State Beach',
      players: []
    },
    {
      value: 'UC Davis Aggies',
      players: []
    },
    {
      value: 'UC Irvine Anteaters',
      players: []
    },
    {
      value: 'UC Riverside Highlanders',
      players: []
    },
    {
      value: 'UC San Diego Tritons',
      players: []
    },
    {
      value: 'UC Santa Barbara Gauchos',
      players: []
    },
    {
      value: 'Charleston Cougars',
      players: []
    },
    {
      value: 'Delaware Blue Hens',
      players: []
    },
    {
      value: 'Drexel Dragons',
      players: []
    },
    {
      value: 'Elon Phoenix',
      players: []
    },
    {
      value: 'Hampton Pirates',
      players: []
    },
    {
      value: 'Hofstra Pride',
      players: []
    },
    {
      value: 'Monmouth Hawks',
      players: []
    },
    {
      value: 'North Carolina A&T Aggies',
      players: []
    },
    {
      value: 'Northeastern Huskies',
      players: []
    },
    {
      value: 'Stony Brook Seawolves',
      players: []
    },
    {
      value: 'Towson Tigers',
      players: []
    },
    {
      value: 'UNC Wilmington Seahawks',
      players: []
    },
    {
      value: 'William & Mary Tribe',
      players: []
    },
    {
      value: 'Charlotte 49ers',
      players: []
    },
    {
      value: 'Florida Atlantic Owls',
      players: []
    },
    {
      value: 'Florida International Panthers',
      players: []
    },
    {
      value: 'Louisiana Tech Bulldogs',
      players: []
    },
    {
      value: 'Middle Tennessee Blue Raiders',
      players: []
    },
    {
      value: 'North Texas Mean Green',
      players: []
    },
    {
      value: 'Rice Owls',
      players: []
    },
    {
      value: 'UAB Blazers',
      players: []
    },
    {
      value: 'UTEP Miners',
      players: []
    },
    {
      value: 'UTSA Roadrunners',
      players: []
    },
    {
      value: 'Western Kentucky Hilltoppers',
      players: []
    },
    {
      value: 'Chicago State Cougars',
      players: []
    },
    {
      value: 'Hartford Hawks',
      players: []
    },
    {
      value: 'Cleveland State Vikings',
      players: []
    },
    {
      value: 'Detroit Mercy Titans',
      players: []
    },
    {
      value: 'Green Bay Phoenix',
      players: []
    },
    {
      value: 'IUPUI Jaguars',
      players: []
    },
    {
      value: 'Milwaukee Panthers',
      players: []
    },
    {
      value: 'Northern Kentucky Norse',
      players: []
    },
    {
      value: 'Oakland Golden Grizzlies',
      players: []
    },
    {
      value: 'Purdue Fort Wayne Mastodons',
      players: []
    },
    {
      value: 'Robert Morris Colonials',
      players: []
    },
    {
      value: 'Wright State Raiders',
      players: []
    },
    {
      value: 'Youngstown State Penguins',
      players: []
    },
    {
      value: 'Brown Bears',
      players: []
    },
    {
      value: 'Columbia Lions',
      players: []
    },
    {
      value: 'Cornell Big Red',
      players: []
    },
    {
      value: 'Dartmouth Big Green',
      players: []
    },
    {
      value: 'Harvard Crimson',
      players: []
    },
    {
      value: 'Pennsylvania Quakers',
      players: []
    },
    {
      value: 'Princeton Tigers',
      players: []
    },
    {
      value: 'Yale Bulldogs',
      players: []
    },
    {
      value: 'Canisius Golden Griffins',
      players: []
    },
    {
      value: 'Fairfield Stags',
      players: []
    },
    {
      value: 'Iona Gaels',
      players: []
    },
    {
      value: 'Manhattan Jaspers',
      players: []
    },
    {
      value: 'Marist Red Foxes',
      players: []
    },
    {
      value: "Mount St. Mary's Mountaineers",
      players: []
    },
    {
      value: 'Niagara Purple Eagles',
      players: []
    },
    {
      value: 'Quinnipiac Bobcats',
      players: []
    },
    {
      value: 'Rider Broncs',
      players: []
    },
    {
      value: "Saint Peter's Peacocks",
      players: []
    },
    {
      value: 'Siena Saints',
      players: []
    },
    {
      value: 'Akron Zips',
      players: []
    },
    {
      value: 'Ball State Cardinals',
      players: []
    },
    {
      value: 'Bowling Green Falcons',
      players: []
    },
    {
      value: 'Buffalo Bulls',
      players: []
    },
    {
      value: 'Central Michigan Chippewas',
      players: []
    },
    {
      value: 'Eastern Michigan Eagles',
      players: []
    },
    {
      value: 'Kent State Golden Flashes',
      players: []
    },
    {
      value: 'Miami (OH) Redhawks',
      players: []
    },
    {
      value: 'Northern Illinois Huskies',
      players: []
    },
    {
      value: 'Ohio Bobcats',
      players: []
    },
    {
      value: 'Toledo Rockets',
      players: []
    },
    {
      value: 'Western Michigan Broncos',
      players: []
    },
    {
      value: 'Coppin State Eagles',
      players: []
    },
    {
      value: 'Delaware State Hornets',
      players: []
    },
    {
      value: 'Howard Bison',
      players: []
    },
    {
      value: 'Maryland-Eastern Shore Hawks',
      players: []
    },
    {
      value: 'Morgan State Bears',
      players: []
    },
    {
      value: 'Norfolk State Spartans',
      players: []
    },
    {
      value: 'North Carolina Central Eagles',
      players: []
    },
    {
      value: 'South Carolina State Bulldogs',
      players: []
    },
    {
      value: 'Belmont Bruins',
      players: []
    },
    {
      value: 'Bradley Braves',
      players: []
    },
    {
      value: 'Drake Bulldogs',
      players: []
    },
    {
      value: 'Evansville Purple Aces',
      players: []
    },
    {
      value: 'Illinois State Redbirds',
      players: []
    },
    {
      value: 'Indiana State Sycamores',
      players: []
    },
    {
      value: 'Missouri State Bears',
      players: []
    },
    {
      value: 'Murray State Racers',
      players: []
    },
    {
      value: 'Northern Iowa Panthers',
      players: []
    },
    {
      value: 'Southern Illinois Salukis',
      players: []
    },
    {
      value: 'UIC Flames',
      players: []
    },
    {
      value: 'Valparaiso Beacons',
      players: []
    },
    {
      value: 'Air Force Falcons',
      players: []
    },
    {
      value: 'Boise State Broncos',
      players: []
    },
    {
      value: 'Colorado State Rams',
      players: []
    },
    {
      value: 'Fresno State Bulldogs',
      players: []
    },
    {
      value: 'Nevada Wolf Pack',
      players: []
    },
    {
      value: 'New Mexico Lobos',
      players: []
    },
    {
      value: 'San Diego State Aztecs',
      players: []
    },
    {
      value: 'San José State Spartans',
      players: []
    },
    {
      value: 'UNLV Rebels',
      players: []
    },
    {
      value: 'Utah State Aggies',
      players: []
    },
    {
      value: 'Wyoming Cowboys',
      players: []
    },
    {
      value: 'Central Connecticut Blue Devils',
      players: []
    },
    {
      value: 'Fairleigh Dickinson Knights',
      players: []
    },
    {
      value: 'Long Island University Sharks',
      players: []
    },
    {
      value: 'Merrimack Warriors',
      players: []
    },
    {
      value: 'Sacred Heart Pioneers',
      players: []
    },
    {
      value: 'St. Francis (PA) Red Flash',
      players: []
    },
    {
      value: 'St. Francis Brooklyn Terriers',
      players: []
    },
    {
      value: 'Stonehill Skyhawks',
      players: []
    },
    {
      value: 'Wagner Seahawks',
      players: []
    },
    {
      value: 'Eastern Illinois Panthers',
      players: []
    },
    {
      value: 'Lindenwood Lions',
      players: []
    },
    {
      value: 'Little Rock Trojans',
      players: []
    },
    {
      value: 'Morehead State Eagles',
      players: []
    },
    {
      value: 'SIU Edwardsville Cougars',
      players: []
    },
    {
      value: 'Southeast Missouri State Redhawks',
      players: []
    },
    {
      value: 'Southern Indiana Screaming Eagles',
      players: []
    },
    {
      value: 'Tennessee State Tigers',
      players: []
    },
    {
      value: 'Tennessee Tech Golden Eagles',
      players: []
    },
    {
      value: 'UT Martin Skyhawks',
      players: []
    },
    {
      value: 'Arizona State Sun Devils',
      players: []
    },
    {
      value: 'Arizona Wildcats',
      players: []
    },
    {
      value: 'California Golden Bears',
      players: []
    },
    {
      value: 'Colorado Buffaloes',
      players: []
    },
    {
      value: 'Oregon Ducks',
      players: []
    },
    {
      value: 'Oregon State Beavers',
      players: []
    },
    {
      value: 'Stanford Cardinal',
      players: []
    },
    {
      value: 'UCLA Bruins',
      players: []
    },
    {
      value: 'USC Trojans',
      players: []
    },
    {
      value: 'Utah Utes',
      players: []
    },
    {
      value: 'Washington Huskies',
      players: []
    },
    {
      value: 'Washington State Cougars',
      players: []
    },
    {
      value: 'American University Eagles',
      players: []
    },
    {
      value: 'Army Black Knights',
      players: []
    },
    {
      value: 'Boston University Terriers',
      players: []
    },
    {
      value: 'Bucknell Bison',
      players: []
    },
    {
      value: 'Colgate Raiders',
      players: []
    },
    {
      value: 'Holy Cross Crusaders',
      players: []
    },
    {
      value: 'Lafayette Leopards',
      players: []
    },
    {
      value: 'Lehigh Mountain Hawks',
      players: []
    },
    {
      value: 'Loyola Maryland Greyhounds',
      players: []
    },
    {
      value: 'Navy Midshipmen',
      players: []
    },
    {
      value: 'Alabama Crimson Tide',
      players: []
    },
    {
      value: 'Arkansas Razorbacks',
      players: []
    },
    {
      value: 'Auburn Tigers',
      players: []
    },
    {
      value: 'Florida Gators',
      players: []
    },
    {
      value: 'Georgia Bulldogs',
      players: []
    },
    {
      value: 'Kentucky Wildcats',
      players: []
    },
    {
      value: 'LSU Tigers',
      players: []
    },
    {
      value: 'Mississippi State Bulldogs',
      players: []
    },
    {
      value: 'Missouri Tigers',
      players: []
    },
    {
      value: 'Ole Miss Rebels',
      players: []
    },
    {
      value: 'South Carolina Gamecocks',
      players: []
    },
    {
      value: 'Tennessee Volunteers',
      players: []
    },
    {
      value: 'Texas A&M Aggies',
      players: []
    },
    {
      value: 'Vanderbilt Commodores',
      players: []
    },
    {
      value: 'Chattanooga Mocs',
      players: []
    },
    {
      value: 'East Tennessee State Buccaneers',
      players: []
    },
    {
      value: 'Furman Paladins',
      players: []
    },
    {
      value: 'Mercer Bears',
      players: []
    },
    {
      value: 'Samford Bulldogs',
      players: []
    },
    {
      value: 'The Citadel Bulldogs',
      players: []
    },
    {
      value: 'UNC Greensboro Spartans',
      players: []
    },
    {
      value: 'VMI Keydets',
      players: []
    },
    {
      value: 'Western Carolina Catamounts',
      players: []
    },
    {
      value: 'Wofford Terriers',
      players: []
    },
    {
      value: 'Houston Christian Huskies',
      players: []
    },
    {
      value: 'Incarnate Word Cardinals',
      players: []
    },
    {
      value: 'Lamar Cardinals',
      players: []
    },
    {
      value: 'McNeese Cowboys',
      players: []
    },
    {
      value: 'New Orleans Privateers',
      players: []
    },
    {
      value: 'Nicholls Colonels',
      players: []
    },
    {
      value: 'Northwestern State Demons',
      players: []
    },
    {
      value: 'SE Louisiana Lions',
      players: []
    },
    {
      value: 'Texas A&M-Commerce Lions',
      players: []
    },
    {
      value: 'Texas A&M-Corpus Christi Islanders',
      players: []
    },
    {
      value: 'Alabama A&M Bulldogs',
      players: []
    },
    {
      value: 'Alabama State Hornets',
      players: []
    },
    {
      value: 'Alcorn State Braves',
      players: []
    },
    {
      value: 'Arkansas-Pine Bluff Golden Lions',
      players: []
    },
    {
      value: 'Bethune-Cookman Wildcats',
      players: []
    },
    {
      value: 'Florida A&M Rattlers',
      players: []
    },
    {
      value: 'Grambling Tigers',
      players: []
    },
    {
      value: 'Jackson State Tigers',
      players: []
    },
    {
      value: 'Mississippi Valley State Delta Devils',
      players: []
    },
    {
      value: 'Prairie View A&M Panthers',
      players: []
    },
    {
      value: 'Southern Jaguars',
      players: []
    },
    {
      value: 'Texas Southern Tigers',
      players: []
    },
    {
      value: 'Denver Pioneers',
      players: []
    },
    {
      value: 'Kansas City Roos',
      players: []
    },
    {
      value: 'North Dakota Fighting Hawks',
      players: []
    },
    {
      value: 'North Dakota State Bison',
      players: []
    },
    {
      value: 'Omaha Mavericks',
      players: []
    },
    {
      value: 'Oral Roberts Golden Eagles',
      players: []
    },
    {
      value: 'South Dakota Coyotes',
      players: []
    },
    {
      value: 'South Dakota State Jackrabbits',
      players: []
    },
    {
      value: 'St. Thomas - Minnesota Tommies',
      players: []
    },
    {
      value: 'Western Illinois Leathernecks',
      players: []
    },
    {
      value: 'Appalachian State Mountaineers',
      players: []
    },
    {
      value: 'Arkansas State Red Wolves',
      players: []
    },
    {
      value: 'Coastal Carolina Chanticleers',
      players: []
    },
    {
      value: 'Georgia Southern Eagles',
      players: []
    },
    {
      value: 'Georgia State Panthers',
      players: []
    },
    {
      value: 'James Madison Dukes',
      players: []
    },
    {
      value: "Louisiana Ragin' Cajuns",
      players: []
    },
    {
      value: 'Marshall Thundering Herd',
      players: []
    },
    {
      value: 'Old Dominion Monarchs',
      players: []
    },
    {
      value: 'South Alabama Jaguars',
      players: []
    },
    {
      value: 'Southern Miss Golden Eagles',
      players: []
    },
    {
      value: 'Texas State Bobcats',
      players: []
    },
    {
      value: 'Troy Trojans',
      players: []
    },
    {
      value: 'UL Monroe Warhawks',
      players: []
    },
    {
      value: 'BYU Cougars',
      players: []
    },
    {
      value: 'Gonzaga Bulldogs',
      players: []
    },
    {
      value: 'Loyola Marymount Lions',
      players: []
    },
    {
      value: 'Pacific Tigers',
      players: []
    },
    {
      value: 'Pepperdine Waves',
      players: []
    },
    {
      value: 'Portland Pilots',
      players: []
    },
    {
      value: "Saint Mary's Gaels",
      players: []
    },
    {
      value: 'San Diego Toreros',
      players: []
    },
    {
      value: 'San Francisco Dons',
      players: []
    },
    {
      value: 'Santa Clara Broncos',
      players: []
    },
    {
      value: 'Abilene Christian Wildcats',
      players: []
    },
    {
      value: 'California Baptist Lancers',
      players: []
    },
    {
      value: 'Grand Canyon Lopes',
      players: []
    },
    {
      value: 'New Mexico State Aggies',
      players: []
    },
    {
      value: 'Sam Houston Bearkats',
      players: []
    },
    {
      value: 'Seattle U Redhawks',
      players: []
    },
    {
      value: 'Southern Utah Thunderbirds',
      players: []
    },
    {
      value: 'Stephen F. Austin Lumberjacks',
      players: []
    },
    {
      value: 'Tarleton Texans',
      players: []
    },
    {
      value: 'UT Arlington Mavericks',
      players: []
    },
    {
      value: 'UT Rio Grande Valley Vaqueros',
      players: []
    },
    {
      value: 'Utah Tech Trailblazers',
      players: []
    },
    {
      value: 'Utah Valley Wolverines',
      players: []
    }
  ]
};

export default teams;
